(() => {
  // ✅ FREE SHIPPING SET TO £50
  const FREE_SHIPPING_THRESHOLD_GBP = 50;
  const threshold = Math.round(FREE_SHIPPING_THRESHOLD_GBP * 100);

  const selectors = [
    '#CartDrawer .drawer__footer',
    '#CartDrawer .cart-drawer__footer',
    '#cart-drawer .drawer__footer',
    '.cart-drawer .drawer__footer',
    '.cart-drawer__footer'
  ];

  function findFooter() {
    for (const sel of selectors) {
      const el = document.querySelector(sel);
      if (el) return el;
    }
    return null;
  }

  function formatGBP(pence) {
    const pounds = (pence / 100).toFixed(2);
    return `£${pounds}`;
  }

  function ensureWidget(footer) {
    let wrap = footer.querySelector('.gq-free-ship');
    if (wrap) return wrap;

    wrap = document.createElement('div');
    wrap.className = 'gq-free-ship';
    wrap.innerHTML = `
      <div class="gq-free-ship__text"></div>
      <div class="gq-free-ship__bar">
        <div class="gq-free-ship__fill"></div>
      </div>
    `;

    footer.prepend(wrap);
    return wrap;
  }

  async function update() {
    const footer = findFooter();
    if (!footer) return;

    const widget = ensureWidget(footer);
    const textEl = widget.querySelector('.gq-free-ship__text');
    const fillEl = widget.querySelector('.gq-free-ship__fill');

    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      const total = cart.total_price;

      if (total >= threshold) {
        textEl.textContent = '✅ You’ve unlocked FREE tracked shipping!';
        fillEl.style.width = '100%';
      } else {
        const remaining = threshold - total;
        const progress = Math.max(0, Math.min(100, Math.round((total / threshold) * 100)));
        textEl.textContent = `You’re ${formatGBP(remaining)} away from FREE tracked shipping.`;
        fillEl.style.width = `${progress}%`;
      }
    } catch (e) {
      textEl.textContent = '';
      fillEl.style.width = '0%';
    }
  }

  document.addEventListener('DOMContentLoaded', update);
  document.addEventListener('cart:refresh', update);

  document.addEventListener('change', (e) => {
    if (e.target && (e.target.name === 'updates[]' || e.target.className?.includes('quantity'))) {
      setTimeout(update, 400);
    }
  });

  const observer = new MutationObserver(() => update());
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();